module.exports = __webpack_public_path__ + "static/media/veggie animal 2.f62481bb.jpg";